export const ensureType = <T>(value: T): T => {
  return value;
};
